import { Pipe, PipeTransform } from '@angular/core';

import { Info } from 'luxon';

@Pipe({
    name: 'monthName',
    standalone: false
})
export class MonthNamePipe implements PipeTransform {
    transform(value: number): string {
        return Info.months()[value - 1];
    }
}
